// extracted by mini-css-extract-plugin
module.exports = {"root":"Actions_root__7XGPb","wrapper":"Actions_wrapper__H9wXP"};